// AppFooter.js
import React, {useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { useInterval } from 'react-use';
import { TickerRepo, ThreeDaysRepo } from '../../value/AppModel';
import { AppStyle, AppWord } from '../../value/AppConst';
import ValueMisc from '../../value/ValueMisc';

const Padding = 14;
const FooterHeight = AppStyle.AppFooterHeight;

const FooterBox = styled(Box)({
    position: 'fixed', bottom: 0, right: 0, left: 0, height: FooterHeight, boxSizing: 'border-box',
    backgroundColor: '#ddd', color: '#555', fontSize: '0.8rem',
    display: 'flex', alignItems: 'center', //opacity: 0.5,
});

const TimeBox = styled(Box)({ padding: Padding, borderRight: '1px solid #f8f8f8', minWidth: 180, textAlign: 'center', });
const CopyBox = styled(Box)({ flexGrow: 1, padding: Padding, textAlign: 'center', });
const VersionBox = styled(Box)({ padding: Padding, borderLeft: '1px solid #f8f8f8', });

function isMapApp() {
    return window.location.href.indexOf(AppWord.MAP_SUB_URL) > 1;
}

export default function AppFooter() {
    const [time, setTime] = useState(new Date());
    const todayRef = useRef('');

    useInterval(() => {
        if(!isMapApp()) {
            const now = new Date();
            const today = ValueMisc.getYMD(now);
            if(todayRef.current !== today) {
                const yesterday = ValueMisc.getYMD(ValueMisc.getDateAgo(1));
                const tomorrow = ValueMisc.getYMD(ValueMisc.getDateAgo(-1));
                ThreeDaysRepo({yesterday, today, tomorrow});
                todayRef.current = today;
            }
            setTime(now);
            TickerRepo(now.getTime()/1000);
        }
    }, 1000);

    // 지도 앱에서는 푸터를 표시하지 않는다.
    if(isMapApp()) return null;

    return(
        <FooterBox>
            <TimeBox>{time.toLocaleString()}</TimeBox>
            <CopyBox>Copyrightⓒ 홈플러스(주) 2026 All right reserved.</CopyBox>
            <VersionBox>NewTOP Version {process.env.REACT_APP_VERSION}</VersionBox>
        </FooterBox>
    );
}